import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog({
  open = false,
  onClose,
  title = 'Confirm Modal',
  content = 'Are you sure?',
  confirmButton = 'Confirm',
  confirmButtonProps = {},
  cancelButton = 'Cancel',
  loading = false,
  onConfirm,
}) {
  const handleClose = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose}>
            {cancelButton}
          </Button>
          <Button disabled={loading} onClick={handleConfirm} autoFocus {...confirmButtonProps}>
            {confirmButton}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
